import { CompositeDecorator } from 'draft-js';
import Link from './link';
import {
    TextSourceBindDecorator
} from '../../../Settings/page-builder/blocks/textSourceBindDecorator';

const findLinkEntities = (contentBlock: any, callback: any, contentState: any) => {
    contentBlock.findEntityRanges(
        (character: any) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'LINK'
            );
        },
        callback
    );
};

const decorator = new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: Link
    },
    {
        strategy: (contentBlock, callback, contentState) => {
            contentBlock.findEntityRanges(
                (character) => {
                    const entityKey = character.getEntity();
                    return (
                        entityKey !== null &&
                        contentState.getEntity(entityKey).getType() === 'SOURCE'
                    );
                },
                callback
            );
        },
        component: TextSourceBindDecorator
    }
]);

export default decorator;
